import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FloorPlanRoutingModule } from './floor-plan-routing.module';
import { FloorPlanComponent } from './floor-plan.component';
import { TableGridComponent } from './components/table-grid/table-grid.component';
import { TableConfigComponent } from './components/table-config/table-config.component';
import { ZoneSelectorComponent } from './components/zone-selector/zone-selector.component';

@NgModule({
  declarations: [
    FloorPlanComponent,
    TableGridComponent,
    TableConfigComponent,
    ZoneSelectorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FloorPlanRoutingModule
  ]
})
export class FloorPlanModule { }
